
import { FaFilter, FaTimes } from "react-icons/fa";
import { VALIDATION_STATUS } from "../../../../service/utils/validationStatus";

/**
 * COMPOSANT FILTRES - Interface professionnelle avec selects
 */
const OrderFilters = ({
  selectedStatusFilter,
  validationStatusFilter,
  onStatusFilterChange,
  onValidationStatusFilterChange,
  onResetFilters,
  totalResults,
  isFiltered,
  disabled = false
}) => {
  // Options de statut d'ordre
  const statusOptions = [
    { value: null, label: 'Tous les statuts', color: 'primary' },
    { value: 'Completed', label: 'Complété', color: 'success' },
    { value: 'PendingValidation', label: 'Validation en attente', color: 'warning' },
    { value: 'PendingExecution', label: 'En cours d\'exécution', color: 'info' },
    { value: 'Partially', label: 'Partiel', color: 'secondary' },
    { value: 'ValidationRejected', label: 'Validation rejetée', color: 'danger' },
    { value: 'Echec Completed', label: 'Échec transaction', color: 'danger' },
    { value: 'Canceled', label: 'Annulé', color: 'dark' }
  ];

  // Options de statut de validation
  const validationOptions = [
    { value: null, label: 'Tous les statuts de validation' },
    { value: VALIDATION_STATUS.DRAFT, label: 'Brouillon' },
    { value: VALIDATION_STATUS.PENDING, label: 'En attente de validation' },
    { value: VALIDATION_STATUS.VALIDATED, label: 'Validé' },
    { value: VALIDATION_STATUS.REJECTED, label: 'Rejeté' }
  ];

  const activeStatusOption = statusOptions.find(opt => opt.value === selectedStatusFilter);

  return (
    <div className="order-filters-container">
      <div className="filters-header">
        <div className="filters-title">
          <FaFilter className="filter-icon" />
          <span>Filtres</span>
          {isFiltered && (
            <span className="results-badge">
              {totalResults} résultat{totalResults > 1 ? 's' : ''}
            </span>
          )}
        </div>
        
        {isFiltered && (
          <button 
            className="btn-reset-filters"
            onClick={onResetFilters}
            title="Réinitialiser tous les filtres"
          >
            <FaTimes />
            <span>Réinitialiser</span>
          </button>
        )}
      </div>

      <div className="filters-row">
        {/* Select Statut d'ordre */}
        <div className="filter-group">
          <label className="filter-label">Statut de l'ordre</label>
          <div className="custom-select-wrapper">
            <select 
              className="custom-select"
              value={selectedStatusFilter || ""}
              onChange={(e) => onStatusFilterChange(e.target.value || null)}
              disabled={disabled}
            >
              {statusOptions.map((option) => (
                <option key={option.label} value={option.value || ""}>
                  {option.label}
                </option>
              ))}
            </select>
            {selectedStatusFilter && (
              <span className={`status-indicator bg-${activeStatusOption?.color}`} />
            )}
          </div>
        </div>

        {/* Select Statut de validation */}
        <div className="filter-group">
          <label className="filter-label">Statut de validation</label>
          <div className="custom-select-wrapper">
            <select 
              className="custom-select"
              value={validationStatusFilter ?? ""}
              onChange={(e) => {
                const value = e.target.value;
                onValidationStatusFilterChange(value ? parseInt(value) : null);
              }}
              disabled={disabled}
            >
              {validationOptions.map((option) => (
                <option key={option.value ?? 'all'} value={option.value ?? ""}>
                  {option.label}
                </option>
              ))}
            </select>
            {validationStatusFilter !== null && (
              <span className="validation-indicator" />
            )}
          </div>
        </div>

        {/* Tags de filtres actifs */}
        {isFiltered && (
          <div className="active-filters">
            {selectedStatusFilter && (
              <span className={`filter-tag bg-${activeStatusOption?.color} bg-opacity-10 text-${activeStatusOption?.color}`}>
                {activeStatusOption?.label}
                <button onClick={() => onStatusFilterChange(null)}>×</button>
              </span>
            )}
            {validationStatusFilter !== null && (
              <span className="filter-tag bg-info bg-opacity-10 text-info">
                {validationOptions.find(o => o.value === validationStatusFilter)?.label}
                <button onClick={() => onValidationStatusFilterChange(null)}>×</button>
              </span>
            )}
          </div>
        )}
      </div>

      <style>{`
        .order-filters-container {
          background: #f8f9fa;
          border-radius: 12px;
          padding: 1.25rem;
          margin-bottom: 1.5rem;
          border: 1px solid #e9ecef;
        }
          
        .custom-select:disabled {
          background: #f8f9fa !important;
          opacity: 0.6;
          cursor: not-allowed;
        }

        .filters-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
        }

        .filters-title {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-weight: 600;
          color: #495057;
          font-size: 0.95rem;
        }

        .filter-icon {
          color: #6c757d;
          font-size: 0.875rem;
        }

        .results-badge {
          background: #dee2e6;
          color: #495057;
          padding: 0.2rem 0.6rem;
          border-radius: 20px;
          font-size: 0.75rem;
          font-weight: 600;
          margin-left: 0.5rem;
        }

        .btn-reset-filters {
          display: flex;
          align-items: center;
          gap: 0.4rem;
          padding: 0.4rem 0.875rem;
          border: 1px solid #dee2e6;
          background: white;
          border-radius: 20px;
          font-size: 0.8rem;
          color: #6c757d;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .btn-reset-filters:hover {
          background: #f8f9fa;
          border-color: #adb5bd;
          color: #495057;
        }

        .filters-row {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          align-items: flex-end;
        }

        .filter-group {
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
          min-width: 220px;
          flex: 1;
          max-width: 300px;
        }

        .filter-label {
          font-size: 0.8rem;
          font-weight: 600;
          color: #6c757d;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }

        .custom-select-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }

        .custom-select {
          width: 100%;
          padding: 0.625rem 2.5rem 0.625rem 1rem;
          border: 1.5px solid #dee2e6;
          border-radius: 8px;
          background: white;
          font-size: 0.9rem;
          color: #495057;
          cursor: pointer;
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236c757d' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 1rem center;
          transition: all 0.2s ease;
        }

        .custom-select:hover {
          border-color: #adb5bd;
        }

        .custom-select:focus {
          outline: none;
          border-color: #86b7fe;
          box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
        }

        .status-indicator,
        .validation-indicator {
          position: absolute;
          right: 2.5rem;
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }

        .validation-indicator {
          background: #0dcaf0;
        }

        .active-filters {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          align-items: center;
          padding-left: 0.5rem;
        }

        .filter-tag {
          display: inline-flex;
          align-items: center;
          gap: 0.4rem;
          padding: 0.35rem 0.75rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 500;
        }

        .filter-tag button {
          background: none;
          border: none;
          padding: 0;
          margin: 0;
          font-size: 1.1rem;
          line-height: 1;
          cursor: pointer;
          opacity: 0.6;
          transition: opacity 0.2s;
        }

        .filter-tag button:hover {
          opacity: 1;
        }

        @media (max-width: 768px) {
          .filters-row {
            flex-direction: column;
          }
          
          .filter-group {
            max-width: 100%;
            width: 100%;
          }
          
          .active-filters {
            padding-left: 0;
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default OrderFilters;